var escape = require("../css-loader/lib/url/escape.js");
exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fullscreen-icon{background-image:url(" + escape(require("./icon-fullscreen.png")) + ")}.leaflet-retina .fullscreen-icon{background-image:url(" + escape(require("./icon-fullscreen-2x.png")) + ");background-size:26px 26px}.leaflet-container:-webkit-full-screen{width:100%!important;height:100%!important;z-index:99999}.leaflet-container:-ms-fullscreen{width:100%!important;height:100%!important;z-index:99999}.leaflet-container:full-screen,.leaflet-container:fullscreen,.leaflet-pseudo-fullscreen{width:100%!important;height:100%!important;z-index:99999}.leaflet-pseudo-fullscreen{position:fixed!important;top:0!important;left:0!important}", ""]);

// exports
